var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPottedPlantFill1Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6 46.4q-1.6 0-2.825-.9T12.1 43l-2.4-9.65h28.65L35.95 43q-.5 1.6-1.725 2.5-1.225.9-2.775.9ZM24 14.8q.25-5.05 4.35-9.2 4.1-4.15 9.2-4.45-.2 4.8-3.6 8.7-3.4 3.9-7.65 4.6v5.4h17.25v6.85q0 1.9-1.325 3.225Q40.9 31.25 39.15 31.25H8.95q-1.85 0-3.15-1.325Q4.5 28.6 4.5 26.7v-6.85h17.25V14.5q-4.3-.7-7.7-4.6-3.4-3.9-3.55-8.75 5.15.3 9.225 4.375Q23.8 9.6 24 14.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPottedPlantFill1Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/potted_plant_FILL1_wght700_GRAD200_opsz48.817dec639a22bc785f24c13920508831.svg";
export { ForwardRef as ReactComponent };